<template>
    <div id="home">
        <Header></Header>
        <loader @onLoadingComplete="onLoadingComplete"></loader>
        <home-page v-show="!loading"></home-page>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/common/Header.vue'
    import HomePage from '../components/pages/HomePage.vue'
    import Footer from '../components/common/Footer'
    import Loader from '../components/common/Loader'

    export default {
        name: 'Home',
        data() {
            return {
                loading: true,
            }
        },
        components: {
            Header,
            HomePage,
            Footer,
            Loader
        },
        methods: {
            onLoadingComplete(stat) {
                this.loading = stat;
            }
        },
        mounted() {
            this.$store.dispatch('getStartupData');
            this.$store.dispatch('getMostUsedKeywordsPosts', 'hirek');
        }
    }
</script>
